import {PaymentSettings} from 'components/customer/Confirmation/Payment/entity/Settings';
import {useFetchPaymentOptionsQuery} from 'components/customer/Confirmation/store/gatewayApi';
import {useJobContext} from 'contexts';
import {useCallback, useEffect, useRef, useState} from 'react';
import {PartialJob} from 'shared/types/PartialJob';

export const usePaymentSettings = () => {
    const {job} = useJobContext() as PartialJob;
    const {data} = useFetchPaymentOptionsQuery(
        {
            jobID: job.id,
        },
        {
            skip: !job?.id,
        }
    );
    const [paymentSettings, setPaymentSettings] = useState<PaymentSettings>();

    const isLoading = useRef(true);
    const dataRef = useRef<PaymentSettings>();

    const getPaymentSettings = useCallback(
        async (maxWaitTime = 10000, pollInterval = 500) => {
            const startTime = Date.now();

            while (isLoading.current) {
                if (Date.now() - startTime > maxWaitTime) {
                    throw new Error(
                        'Timeout waiting for payment settings to load'
                    );
                }

                await new Promise((resolve) =>
                    setTimeout(resolve, pollInterval)
                );
            }

            return dataRef.current;
        },
        []
    );

    useEffect(() => {
        if (data) {
            setPaymentSettings(data.paymentSettings);
            dataRef.current = data.paymentSettings;
            isLoading.current = false;
        }
    }, [data]);

    return {
        paymentSettings,
        getPaymentSettings,
    };
};
